import React from "react";
import { Button, Modal } from "../../../../../../components";

const HoneBModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="HoneB Modal " width="max-w-7xl">
      <div>
        {/* <Button
          type="button"
          variant="outlined"
          title="Cancel"
          onClick={onClose}
        />
        <Button type="button" title="Save" onClick={onClose} /> */}
        H1B modal
      </div>
    </Modal>
  );
};

export default HoneBModal;
